import {
    Action,
    createFeatureSelector,
    createReducer,
    createSelector,
    on
} from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { BudgetUpload } from './budget-upload.model';
import * as BudgetUploadActions from './budget-upload.actions';

export const BudgetUploadsFeatureKey = 'budgetUpload';

export interface State extends EntityState<BudgetUpload> {
    // additional entities state properties
}

export const adapter: EntityAdapter<BudgetUpload> =
    createEntityAdapter<BudgetUpload>({
        selectId: (model: BudgetUpload) => model.ResponseMessage
    });

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

export const BudgetUploadReducer = createReducer(
    initialState,
    on(BudgetUploadActions.addBudgetUpload, (state, action) =>
        adapter.addOne(action.BudgetUpload, state)
    ),
    on(BudgetUploadActions.upsertBudgetUpload, (state, action) =>
        adapter.upsertOne(action.BudgetUpload, state)
    ),
    on(BudgetUploadActions.addBudgetUploads, (state, action) =>
        adapter.addMany(action.BudgetUploads, state)
    ),
    on(BudgetUploadActions.upsertBudgetUploads, (state, action) =>
        adapter.upsertMany(action.BudgetUploads, state)
    ),
    on(BudgetUploadActions.updateBudgetUpload, (state, action) =>
        adapter.updateOne(action.BudgetUpload, state)
    ),
    on(BudgetUploadActions.updateBudgetUploads, (state, action) =>
        adapter.updateMany(action.BudgetUploads, state)
    ),
    on(BudgetUploadActions.deleteBudgetUpload, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(BudgetUploadActions.deleteBudgetUploads, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(BudgetUploadActions.loadBudgetUploads, (state, action) =>
        adapter.setAll(action.BudgetUploads, state)
    ),
    on(BudgetUploadActions.clearBudgetUploads, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return BudgetUploadReducer(state, action);
}

export const selectBudgetUploadState = createFeatureSelector<State>(
    BudgetUploadsFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(selectBudgetUploadState);
